import { COUNTRY_CODE_EN } from './en/country-code';
import { AUTH_EN } from './en/authentication';
import { ERROR_EN } from './en/error';
import { LANDING_EN } from './en/landing';
import { COMMON_EN } from './en/common';
import { MENU_EN } from './en/menu';
import { APPLICATION_EN, APPLICATION_LIST_EN } from './en/application';
import { FORM_EN } from './en/form';
import { ADMIN_EN } from './en/admin';
import { REFERRAL_EN } from './en/referral';

export default {
  // General
  ...COMMON_EN,
  ...ERROR_EN,
  ...COUNTRY_CODE_EN,

  // Menu
  ...MENU_EN,

  // Page Specific
  ...LANDING_EN,
  ...AUTH_EN,
  ...APPLICATION_LIST_EN,
  ...APPLICATION_EN,
  ...ADMIN_EN,

  // Form
  ...FORM_EN,

  // Referral
  ...REFERRAL_EN,
};
